<template>
  <v-app>
    <v-container fluid class="article-actions">
      <v-row>
        <v-col cols="4">
          <v-subheader>عنوان</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-text-field placeholder="عنوان" v-model="title"></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-btn class="ml-4 white--text font-weight-bold indigo darken-4 white--text" @click="editHandler">
          ثبت کردن
        </v-btn>
        <router-link to='/product-management/brand'>
          <v-btn class=" white--text font-weight-bold indigo lighten-2"> انصراف </v-btn>
        </router-link>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import baseURL from '@/axios'
export default {
  data() {
    return {
      title: "",
    };
  },
  computed: {
    ...mapGetters(["tokenValue"]),
  },
  methods: {
    async editHandler() {
      await axios
        .post(
          `${baseURL}shippingType/Add`,
          {
            title: this.title,
          },
          {
            headers: {
              Authorization: `Bearer ${this.tokenValue}`,
            },
          }
        )
        .then(() => {
          this.$router.push("/product-management/shippingType");
        })
    },
  },
};
</script>

<style>
.article-actions {
  background: #ffffff;
  height: auto;
}
.v-input__control {
  direction: ltr;
}
.v-input__slot {
  flex-direction: row-reverse;
}
.v-application--wrap {
  min-height: auto !important;
}
.theme--light.v-input input {
  text-align: right;
}
</style>